

























































































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import CartInSuccessModal from '@/components/molecules/CartInSuccessModal.vue'
import { log } from '@/log'
import RecommendItemsService from '@/services/api/item/fku/recommend-items'
import Newstock from '@ajax/vue/components/templates/Newstock.vue'
import Restock from '@ajax/vue/components/templates/Restock.vue'

import { ActionButtonViewModel } from './action-button-view-model'

@Component({
  components: {
    CartInSuccessModal,
    Restock,
    Newstock,
  },
})
export default class ActionButton extends Vue {
  @Prop({ required: true })
  readonly viewModel: ActionButtonViewModel

  @Prop({ required: true })
  readonly brandEnglishName: string

  showAddedToCartModal: boolean = false
  recommendItems: any[] = []

  startLoadingRecommendItems(fkuId: string): void {
    // おすすめ商品はカート追加と並行して取得し、確定次第モーダルに遅延で反映する
    this.recommendItems = []
    this.loadRecommendItems(fkuId).then((items) => {
      this.recommendItems = items
    })
  }

  openAddedToCartModal(): void {
    this.showAddedToCartModal = true
  }

  closeAddedToCartModal(): void {
    this.showAddedToCartModal = false
  }

  private async loadRecommendItems(fkuId: string): Promise<any[]> {
    try {
      const result = await new RecommendItemsService()
        .getRecommendItemsForDetail(fkuId, this.brandEnglishName)

      return result.getOrElse([])
    } catch (error) {
      log.error({
        service: 'ActionButton/loadRecommendItems',
        error,
        fkuId,
        brandEnglishName: this.brandEnglishName,
      })

      return []
    }
  }
}
